var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.onaddnote ? "show" : "show",
        style: _vm.onaddnote ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content shadow-3" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
                },
                [_c("i", { staticClass: "bi bi-card-checklist" })]
              ),
              _vm._v(" "),
              _c("div", [
                _c("h5", { staticClass: "mb-1" }, [_vm._v("Nota")]),
                _vm._v(" "),
                _c("small", { staticClass: "d-block text-xs text-muted" }, [
                  _vm._v("Agregar nueva nota."),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ms-auto" }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.note,
                      expression: "data.note",
                    },
                  ],
                  staticClass: "form-control from-control-sm",
                  class: _vm.errors.note ? "is-invalid" : "",
                  attrs: { rows: "10" },
                  domProps: { value: _vm.data.note },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "note", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.note, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-primary px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.ADD(1)
                    },
                  },
                },
                [
                  _vm.count == 1 && _vm.data.option == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Guardar")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-dark px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.ADD(2)
                    },
                  },
                },
                [
                  _vm.count == 1 && _vm.data.option == 2
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Guardar y noficar")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-danger px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("onclose")
                    },
                  },
                },
                [_vm._v("Cancelar")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }